/*
 * ring-size-selector.js
 * リングサイズの範囲スワッチ（例: "4-16"）から、選択範囲内の号数を
 * line item property 用のセレクトボックスに動的展開する。
 * 対象: <ring-size-property> （snippets/ring-size-property.liquid）
 */
if (!customElements.get('ring-size-property')) {
  class RingSizeProperty extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-ring-size-select]');
      this.fieldset =
        this.closest('fieldset.product-variant--picker') ||
        this.closest('[data-ring-size-option]');
      if (!this.select || !this.fieldset) return;

      // 号数セレクトの change は <variant-set-option> まで伝播させない
      // （伝播すると不要な variant 再取得が走るため）
      this.select.addEventListener('change', (e) => e.stopPropagation());

      this._onRangeChange = this._onRangeChange.bind(this);
      this.fieldset.addEventListener('change', this._onRangeChange);

      this.populate();
    }

    disconnectedCallback() {
      if (this.fieldset && this._onRangeChange) {
        this.fieldset.removeEventListener('change', this._onRangeChange);
      }
    }

    _onRangeChange(e) {
      // 号数セレクト自身の変更では作り直さない
      if (e.target === this.select) return;
      this.populate();
    }

    getSelectedRange() {
      const radio = this.fieldset.querySelector('input[type="radio"]:checked');
      if (radio) return radio.value;
      const sel = this.fieldset.querySelector('select.options-select');
      if (sel) return sel.value;
      return null;
    }

    parseRange(range) {
      if (!range) return [];
      const parts = String(range).split('-').map((v) => v.trim());
      if (parts.length === 2) {
        const min = parseInt(parts[0], 10);
        const max = parseInt(parts[1], 10);
        if (!Number.isNaN(min) && !Number.isNaN(max) && min <= max) {
          const out = [];
          for (let i = min; i <= max; i++) out.push(i);
          return out;
        }
      }
      const single = parseInt(parts[0], 10);
      return Number.isNaN(single) ? [] : [single];
    }

    populate() {
      const sizes = this.parseRange(this.getSelectedRange());
      const previous = this.select.value;

      // placeholder（value=""）は残して option を作り直す
      const placeholder = this.select.querySelector('option[value=""]');
      this.select.innerHTML = '';
      if (placeholder) this.select.appendChild(placeholder);

      sizes.forEach((n) => {
        const opt = document.createElement('option');
        opt.value = n + '号';
        opt.textContent = n + '号';
        this.select.appendChild(opt);
      });

      // 範囲変更後も同じ号数が選べれば維持、なければ未選択へ戻す
      if (previous && sizes.map((n) => n + '号').includes(previous)) {
        this.select.value = previous;
      } else {
        this.select.selectedIndex = 0;
      }
    }
  }
  customElements.define('ring-size-property', RingSizeProperty);
}
